import { gql } from '@apollo/client';

export const VEHICLE_BY_AUDICODE = gql`
  query CarByCode($code: String!, $filterInput: RenderedCarImagesFilterInput) {
    carByCode(code: $code) {
      ... on ConfiguredCar {
        carline {
          id
          name
        }
        media {
          images(filterInput: $filterInput) {
            url
          }
        }
        model {
          id {
            year
          }
          name
        }
      }
    }
  }
`;
